module.exports = __webpack_public_path__ + "media/images/logo-horizontal-a9b439c74b90ba8b64376c762ff98990.svg";